import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { renderToStaticMarkup } from 'react-dom/server'
import { Image, Section, Link } from 'newComponents'
import BlogUtm from '../../utils/BlogUtm'
import './styles.scss'

const CtaQuery = graphql`
  query {
    ...middleCta
  }
`

const BlogCta = () => {
  const { prismicSettings } = useStaticQuery(CtaQuery)
  const { data: ctaData } = prismicSettings
  const { middle_cta_image: image, middle_cta_link: link, ctas_active: active } = ctaData

  if (!active || !image?.url || !link?.url) return null

  return (
    <Section className="blog-cta-slice">
      <a data-blogutm="blog_cta_middle" className="blog-cta-slice-link" href={link?.url} target="_blank" rel="noreferrer">
        <Image className="blog-cta-slice-image" image={image} />
      </a>
    </Section>
  )
}

export default BlogCta
